export const ALL_PROVINCES = ['ON', 'QC', 'NS', 'NB', 'MB', 'BC', 'PE', 'SK', 'AB', 'NL', 'NU', 'NT', 'YT'] as const;

export type Province = (typeof ALL_PROVINCES)[number];

export type Jurisdiction = 'federal' | 'provincial';
